import React from 'react';

import PropTypes from 'prop-types';

const VideoMuteIcon = ({ width = 34, height = 32, color = 'white' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 34 32"
      fill="none"
    >
      <g filter="url(#filter0_d_19689_91217)">
        <path
          d="M19.0791 5.07579C18.9529 5.01433 18.8121 4.98948 18.6726 5.00406C18.533 5.01865 18.4004 5.07208 18.2897 5.15829L11.7422 10.2498H7.5C7.10218 10.2498 6.72064 10.4079 6.43934 10.6892C6.15804 10.9705 6 11.352 6 11.7498V17.7498C6 18.1477 6.15804 18.5292 6.43934 18.8105C6.72064 19.0918 7.10218 19.2498 7.5 19.2498H11.7422L18.2897 24.3414C18.4005 24.4275 18.5332 24.4809 18.6728 24.4953C18.8124 24.5097 18.9533 24.4847 19.0793 24.4231C19.2054 24.3615 19.3117 24.2657 19.3861 24.1467C19.4604 24.0277 19.4999 23.8902 19.5 23.7498V5.74985C19.5 5.60934 19.4606 5.47166 19.3861 5.35248C19.3117 5.23331 19.2053 5.13743 19.0791 5.07579ZM7.5 11.7498H11.25V17.7498H7.5V11.7498Z"
          fill={color}
          fillOpacity="0.9"
        />
        <path
          d="M25.8107 14.7504L27.531 13.031C27.6718 12.8903 27.7508 12.6994 27.7508 12.5004C27.7508 12.3014 27.6718 12.1105 27.531 11.9698C27.3903 11.8291 27.1994 11.75 27.0004 11.75C26.8014 11.75 26.6105 11.8291 26.4698 11.9698L24.7504 13.6901L23.031 11.9698C22.8903 11.8291 22.6994 11.75 22.5004 11.75C22.3014 11.75 22.1105 11.8291 21.9698 11.9698C21.8291 12.1105 21.75 12.3014 21.75 12.5004C21.75 12.6994 21.8291 12.8903 21.9698 13.031L23.6901 14.7504L21.9698 16.4698C21.8291 16.6105 21.75 16.8014 21.75 17.0004C21.75 17.1994 21.8291 17.3903 21.9698 17.531C22.1105 17.6718 22.3014 17.7508 22.5004 17.7508C22.6994 17.7508 22.8903 17.6718 23.031 17.531L24.7504 15.8107L26.4698 17.531C26.6105 17.6718 26.8014 17.7508 27.0004 17.7508C27.1994 17.7508 27.3903 17.6718 27.531 17.531C27.6718 17.3903 27.7508 17.1994 27.7508 17.0004C27.7508 16.8014 27.6718 16.6105 27.531 16.4698L25.8107 14.7504Z"
          fill={color}
          fillOpacity="0.9"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_19689_91217"
          x="-5.5"
          y="-7.25"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_19689_91217"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_19689_91217"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

VideoMuteIcon.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default VideoMuteIcon;
